import React from 'react';
import { FCC } from 'react';
import { IBigListItemProps } from './types';

import './BigListItem.scss';

export const BigListItem: FCC<IBigListItemProps> = (props) => {
  const bigNumber = props.itemNumber ? props.itemNumber.toString() : '';

  return (
    <li className="hlc-big-ordered-list-item" qa-id={props['qa-id']}>
      <div className="big-ordered-list-item-number">{bigNumber}</div>
      <div className={'big-ordered-list-item-content'}>
        <h3>
          <span className="sr-only">{bigNumber}</span>
          {props.title}
        </h3>
        <div>{props.children}</div>
      </div>
    </li>
  );
};

export default BigListItem;
